import { Component, input, output, signal } from '@angular/core';

export interface TemplateSelectItem {
  uId: string;
  name: string;
  badgeText?: string;
}

@Component({
  selector: 'topo-template-select-expansion-panel',
  standalone: true,
  templateUrl: './template-select-expansion-panel.component.html',
  styleUrl: './template-select-expansion-panel.component.scss'
})
export class TemplateSelectExpansionPanelComponent {
  label = input.required<string>();
  templates = input.required<TemplateSelectItem[]>();
  onTemplateSelected = output<string>(); // emit uId of template
  forceExpand = input(false);

  protected isExpanded = signal<boolean>(false);

  toggleExpansion(): void {
    this.isExpanded.update(state => !state);
  }
}
